<div class="card" *ngIf="equipment">
  <div class="card-header" style="height: auto">
    <div class="card-header-title my-2">
      <lib-terminal-header
        [equipment]="equipment"
        [link]="'/farming/' + equipment.serialNumber + '/irrigation'"
        [showStatusIcon]="true"
        [connected]="Number(equipment.connected)"
        [irrigating]="isIrrigating(equipment)"
      ></lib-terminal-header>
    </div>
  </div>
  <div class="row mx-0 mx-lg-2 my-3">
    <div class="col-6 col-lg-3 col-xl mb-3">
      <app-info-pill
        [type]="'IRRIGATION'"
        [height]="'56px'"
        [value]="today_consumption"
        [magnitudeLabel]="'irrigation_today_consumption' | translation"
        [magnitudeUnit]="'m³'"
        [icon]="'HUMIDITY'">
      </app-info-pill>
    </div>
    <div class="col-6 col-lg-3 col-xl mb-3">
      <app-info-pill
        [type]="'IRRIGATION'"
        [height]="'56px'"
        [value]="yesterday_ET0"
        [magnitudeLabel]="'daily_et0' | translation"
        [magnitudeUnit]="'mm'"
        [icon]="'ET0'">
      </app-info-pill>
    </div>
    <div class="col-6 col-lg-3 col-xl mb-3">
      <app-info-pill
        [type]="'IRRIGATION'"
        [height]="'56px'"
        [value]="TEMPERATURE"
        [virtual]="temperatureIsVirtual"
        [magnitudeLabel]="'temperature' | translation"
        [magnitudeUnit]="'ºC'"
        [icon]="'TEMPERATURE'">
      </app-info-pill>
    </div>
    <div class="col-6 col-lg-3 col-xl mb-3">
      <app-info-pill
        [type]="'IRRIGATION'"
        [height]="'56px'"
        [value]="HUMIDITY"
        [virtual]="humidityIsVirtual"
        [magnitudeLabel]="'humidity' | translation"
        [magnitudeUnit]="'%'"
        [icon]="'HUMIDITY'">
      </app-info-pill>
    </div>
  </div>
  <div class="row mx-0 mx-lg-2 mb-4">
    <div class="col-12">
      <app-water-systems
        [terminalVid]="equipment.serialNumber"
      ></app-water-systems>
    </div>
  </div>
  <div class="row mx-0 mx-lg-2">
    <div class="col-12 col-xl">
      <div class="row">
        <!-- Calendar -->
        <div class="col-lg-6 col-12">
          <div class="card card-inside">
            <div class="card-header">
              <div class="col-xxl-12 col-6">
                <h4 class="d-inline-block card-header-title me-3">
                  {{ 'calendar_calendar' | translation }}
                </h4>
                <a
                  [routerLink]="[
                    '/terminal-calendar',
                    { vid: equipment.serialNumber }
                  ]"
                  class="btn btn-secondary lift"
                >
                  <ion-icon
                    [ios]="'arrow-redo-outline'"
                    [md]="'arrow-redo-outline'"
                  ></ion-icon>
                </a>
              </div>
            </div>
            <div class="card-body">
              <app-events-calendar-widget
                [mode]="'widget'"
                [terminal_vid]="equipment.serialNumber"
              ></app-events-calendar-widget>
            </div>
          </div>
        </div>
        <!-- Consumptions -->
        <div class="col-lg-6 col-12">
          <div class="card card-inside">
            <div class="card-header">
              <h4 class="d-inline-block card-header-title">
                {{ 'reports_consumptions' | translation }}
              </h4>
            </div>
            <div class="card-body">
              <span class="p-3 text-muted" *ngIf="consumptionNoData === true">
                {{ 'reports_no_data' | translation }}
              </span>

              <highcharts-chart
                [Highcharts]="Highcharts"
                [constructorType]="chartConstructor"
                [options]="consumptionChart"
                [(update)]="updateFlag"
                [callbackFunction]="chartCallback"
                [oneToOne]="true"
                style="width: 100%; height: 400px; display: block"
                *ngIf="consumptionNoData !== true"
              >
              </highcharts-chart>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="card" *ngIf="!equipment && terminal">
  <div class="card-header" style="height: auto">
    <div class="card-header-title my-2">
      <lib-terminal-header
        [equipment]="terminal"
        [link]="'/farming/' + terminal.vid + '/irrigation'"
        [showStatusIcon]="true"
        [connected]="terminal.enabled === TERMINAL_ENABLED_TEMPORARY_DISABLED ? 2 : 0"
      ></lib-terminal-header>
    </div>
  </div>
  <div class="row my-4 mx-2" *ngIf="terminal.enabled !== TERMINAL_ENABLED_TEMPORARY_DISABLED">
    <i>{{ 'no_results' | translation }}</i>
  </div>
  <div class="row mx-2" *ngIf="terminal.enabled === TERMINAL_ENABLED_TEMPORARY_DISABLED">
    <app-terminal-placeholder-data
      [terminalType]="'irrigation'"
      [size]="'small'">
    </app-terminal-placeholder-data>
  </div>
</div>
